import { RootState } from '@/types/store';
import Pusher from 'pusher-js';
import { Store } from 'vuex';

const eventName = process.env.VUE_APP_ENV || 'develop';

const pusher = new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
  cluster: 'eu',
});
const channel = pusher.subscribe('cms-client-deployment');

export default (store: Store<RootState>) => {
  channel.bind(eventName, () => {
    store.dispatch('notifications/setReloadNotification', true);
  });
};
